// extracted by mini-css-extract-plugin
export var barContainer = "_59-0";
export var extraThin = "_59-3";
export var fillBar = "_59-6";
export var fillContainer = "_59-4";
export var overflow = "_59-8";
export var overflowContainer = "_59-5";
export var regular = "_59-7";
export var thick = "_59-1";
export var thin = "_59-2";